'use client';
import React from 'react';

function OpenExpandContent({ row, expandable }) {
  return (
    <tr>
      <td colSpan={row.getVisibleCells().length} className="open-expand-row">
        {expandable.expandedRowRender(row.original)}
      </td>
    </tr>
  );
}
export { OpenExpandContent };
